// components/security/DeviceLimitModal.tsx

"use client";

import React from "react";
import { Modal, Button } from "../common";

interface DeviceLimitModalProps {
  isOpen: boolean;
  limit: number;
  onClose: () => void;
  onManage?: () => void; // optional: navigate to settings
}

/** Shown when API returns 403 { limit } for device registration. */
export default function DeviceLimitModal({
  isOpen,
  limit,
  onClose,
  onManage,
}: DeviceLimitModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Device limit reached"
      hideFooter
      disableBackdropClick
      message={
        <div className="space-y-3">
          <p>
            You’ve reached the maximum number of registered devices ({limit}).
            This device can’t be added right now.
          </p>
          <p className="util-text-hint">
            Please open <strong>Settings → Device &amp; Crypto Security</strong>, remove devices you no
            longer use, then sign out and sign in again on this device to register it.
          </p>
          <div className="modal-footer modal-footer-actions">
            <Button variant="secondary" size="sm" onClick={onClose}>
              Close
            </Button>
            <Button
              variant="primary"
              size="sm"
              onClick={onManage ?? onClose}
            >
              Manage Devices
            </Button>
          </div>
        </div>
      }
    />
  );
}
